import { attributedTransactions } from '../configs/tools/setup/attributed-transactions';
import { defaultCCItemProperties } from '../configs/shared';

export const transactions = {
  ...defaultCCItemProperties,
  id: 'attributed-transactions',
  name: _TL_('Transactions'),
  description: _TL_('Sync transactions data'),
  route: 'Billing/CashbackApproval',
  children: [
    attributedTransactions,
  ],
};
